function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.734 12.898c3.081-3.008 3.011-7.82-.156-10.746C11.411-.774 6.347-.708 3.266 2.3c-3.021 2.95-3.021 7.648 0 10.598l.021.025.026.025.063.06 4.995 4.745c.348.33.91.33 1.257 0l4.995-4.745.064-.06.026-.025.021-.025z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "7.8",
  r: "4.25",
  stroke: "#F1F1F1",
  strokeWidth: "1.5"
}));